import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getVisaProfessionChnagesData = createAsyncThunk(
  "api/visaProfession",
  async (token, Apikey,data) => {
    console.log("key......",data)
    try {
      const response = await nodeinstance.get(`/visaProfession`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data.data;
    } catch (e) {
      throw new Error(e.message);
    }
  }
);

const VisaProfessionChangesDataSlice = createSlice({
  name: "visa-profession",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVisaProfessionChnagesData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getVisaProfessionChnagesData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getVisaProfessionChnagesData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getVisaProfessionChnagesData };
export default VisaProfessionChangesDataSlice.reducer;
